import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import ColoredFormattedNumber from 'components/ColoredFormattedNumber';
import CustomMaskedInput from 'components/MaskedOutput';
import PermissionHide from 'components/PermissionHide';
import React from 'react';

const Values = (props: any) => {
  return (
    <React.Fragment>
      <div className={props.classes.rowValues}>
        <h4>Valores {props.invoice.currency ? props.invoice.currency.currency_symbol : ''}</h4>

        <div className='content__values'>
          <div className='value --number'>
            <div className='value__title'>Venda</div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <CustomMaskedInput mask='money' value={props.invoice.amount} />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>

          <div className='value --number'>
            <div className='value__title'>Taxa Eduzz</div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <CustomMaskedInput mask='money' value={props.invoice.rate_amount ? props.invoice.rate_amount : 0} />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>

          <div className='value --number'>
            <div className='value__title'>Taxa Alumy</div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <CustomMaskedInput mask='money' value={props.invoice.rate_amount_alumy ?? 0} />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>

          <div className='value --number'>
            <div className='value__title'>Comissão</div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <CustomMaskedInput mask='money' value={props.invoice.commission_amount ? props.invoice.commission_amount : 0} />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>

          <div className='value --number'>
            <div className='value__title'>Parceiro</div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <CustomMaskedInput mask='money' value={props.invoice.partner_amount ? props.invoice.partner_amount : 0} />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>

          <div className='value --number'>
            <div className='value__title'>
              Antecipação
              <Tooltip placement='top' title='A antecipação é descontada diretamente no extrato financeiro (valor apenas para conhecimento)'>
                <Icon style={{ fontSize: 14, display: 'inline-block', marginLeft: 5, lineHeight: '16px' }}>info</Icon>
              </Tooltip>
            </div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <CustomMaskedInput mask='money' value={props.invoice.anticipation_amount ? props.invoice.anticipation_amount : 0} />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>

          <div className='value --number'>
            <div className='value__title'>Outros</div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <CustomMaskedInput mask='money' value={props.invoice.others_values ? props.invoice.others_values : 0} />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>

          {props.invoice.refund_values && props.invoice.refund_values.type === 'parcial' && props.invoice.refund_values.partial_value && (
            <div className='value --number'>
              <div className='value__title'>
                Reembolso Parcial
                {props.invoice.refund_values.status_partial_refund === 0 && (
                  <Tooltip placement='top' title='Reembolso em andamento'>
                    <Icon
                      className={'tred'}
                      style={{
                        fontSize: 14,
                        display: 'inline-block',
                        marginLeft: 5,
                        lineHeight: '16px',
                      }}
                    >
                      info
                    </Icon>
                  </Tooltip>
                )}
              </div>
              <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
                <CustomMaskedInput mask='money' value={'-' + props.invoice.refund_values.partial_value} />
              </PermissionHide>
              <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
                <em>oculto</em>
              </PermissionHide>
            </div>
          )}
        </div>
        <div className='content__total'>
          <div>Valor Líquido</div>
          <div>
            <PermissionHide inverse={1} action='myeduzz:minhas-vendas:ocultar-valores'>
              <ColoredFormattedNumber
                disableSymbol
                value={props.invoice.net_income ? props.invoice.net_income : 0}
                format={props.invoice.currency && props.invoice.currency.code}
              />
            </PermissionHide>
            <PermissionHide inverse={false} action='myeduzz:minhas-vendas:ocultar-valores'>
              <em>oculto</em>
            </PermissionHide>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Values;
